import { getWebSocketUrl } from '@util'
import http, { createApi } from '@core/fetch'

export default {
  isReceiveMsg: createApi(
    '/p/wedding/index.php/Admin/APIMerchantSupport/isRecvMsg'
  ),
  getUnreadCount: body => {
    const ws_url = getWebSocketUrl().domain

    return http(`${ws_url}/api/channels/messages/unread_count`, {
      body,
      mode: 'cors'
    })
  }
}
